import React, { useState, useEffect} from 'react';
import { useSelector, useDispatch } from 'react-redux';
import MobilePhoneCalls from './MobilePhoneCalls'
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';

import DialogTitle from '@mui/material/DialogTitle';

import '../css/NotesArea.css';
import Button from '@mui/material/Button';

import {
  setViewPhoneCalls
} from '../slices/dataSlice';

function PopupPhoneCalls(props) {
    const dispatch = useDispatch();

    const [previd,setPrevID] = useState(props.id)
    const auth = useSelector(state => state.auth)
    const {viewPhoneCalls} = useSelector(state => state.data)
    useEffect(()=> {
        async function LoadData() {
          if(props.id===previd) {
            return
          }
          setPrevID(props.id)
        }

        if(auth.token > "" && typeof props.data !== 'undefined' && props.data.id > ""  && props.id > "" ) {
          LoadData();
        }
    },[props.data, auth.token, props.data.id, props.data.uid, props.id, previd]);


    const closeMainCalls = () => {
      dispatch(setViewPhoneCalls(false))
    }
    return (
        <React.Fragment>
        <Dialog
                open={viewPhoneCalls}
                onClose={() => closeMainCalls}
                PaperProps={{component: 'paper'}}
                sx={{width: '600px', marginLeft: 'auto', marginRight: 'auto'}}

                maxWidth="xl"
            >
                <DialogTitle>Phone Calls</DialogTitle>
                <DialogContent>
                  <MobilePhoneCalls data={props.data} />
                </DialogContent>
                <DialogActions>
                  <Button size='sm' variat='outline' onClick={() => dispatch(setViewPhoneCalls(false)) }>Close</Button>
                </DialogActions>
          </Dialog>
    </React.Fragment>

    )
}

export default PopupPhoneCalls;